import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useAuth0Auth } from '@nexus/supabase';

import { useStore } from '../lib/store';
import { getAriCloudUrl } from '../config/global';

/**
 * Hook for managing authentication state via Auth0.
 */
export function useAuth() {
  const queryClient = useQueryClient();
  const setSupabaseUser = useStore((state) => state.setSupabaseUser);
  const setSupabaseSession = useStore((state) => state.setSupabaseSession);
  const setExplicitLogout = useStore((state) => state.setExplicitLogout);

  const auth = useAuth0Auth({
    setUser: setSupabaseUser,
    setSession: setSupabaseSession,
    setExplicitLogout,
    logoutReturnTo: getAriCloudUrl(),
  });

  const signOut = useCallback(async () => {
    // Drop every cached user-scoped query (chats, connectors,
    // skills, memory). The QueryClient lives for the tab lifetime and our
    // query keys are global (not keyed by user id), so a same-tab account
    // switch would otherwise paint the new user's UI with the prior
    // user's cached data until each query refetches.
    queryClient.clear();
    await auth.signOut();
  }, [auth, queryClient]);

  return { ...auth, signOut };
}
